import React from 'react';
import { BookOpenIcon, CalendarCheckIcon, FileTextIcon, SearchCheckIcon } from 'lucide-react';
import { bonos, mainProduct } from '../data/content';
const bonoIcons = [SearchCheckIcon, FileTextIcon, CalendarCheckIcon];
export function IncludedSection() {
  return <section className="w-full bg-paper-deep py-11 sm:py-14 lg:py-16" aria-labelledby="que-incluye" data-id="element-86" data-mp="37hhavvg5p1kq">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-87" data-mp="3cg27zm04354y">
        <p className="font-mono text-[11px] font-bold uppercase tracking-widest text-navy-muted" data-id="element-88" data-mp="3yxrlifgh622">
          Qué recibís
        </p>
        <h2 id="que-incluye" className="mt-2.5 max-w-3xl font-display text-2xl font-extrabold leading-[1.12] tracking-tight text-navy sm:text-4xl" data-id="element-89" data-mp="81u18jn0prtv">
          El manual completo + 3 bonos incluidos sin costo adicional
        </h2>

        {/* Manual principal */}
        <div className="mt-6 flex flex-col gap-4 rounded-2xl border border-navy/10 bg-white p-5 shadow-card sm:flex-row sm:items-center sm:gap-6 sm:p-6" data-id="element-90" data-mp="mv74i2emfqkh">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-navy" aria-hidden="true" data-id="element-91" data-mp="3qi5nj99ugqu0">
            <BookOpenIcon className="h-6 w-6 text-white" data-id="element-92" data-mp="41jay59kcc7q" />
          </span>
          <div data-id="element-93" data-mp="42ufw8eqvq0f">
            <span className="font-mono text-[11px] font-bold uppercase tracking-widest text-celeste-deeper" data-id="element-94" data-mp="43dzrunygoh3">
              {mainProduct.tag}
            </span>
            <h3 className="mt-1 font-display text-xl font-extrabold leading-tight text-navy sm:text-2xl" data-id="element-95" data-mp="dye6cfajhwhs">
              {mainProduct.title}
            </h3>
            <p className="mt-1.5 text-[15px] leading-relaxed text-navy-soft" data-id="element-96" data-mp="n05bnj1641b4">
              {mainProduct.description}
            </p>
          </div>
        </div>

        {/* Bonos */}
        <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-3" data-id="element-97" data-mp="2ors8403twoez">
          {bonos.map((bono, i) => {
          const Icon = bonoIcons[i];
          return <div key={bono.title} className="flex flex-col rounded-2xl border border-oro/40 bg-oro-soft p-5" data-id="element-98" data-mp="2juia3w2dj4fj" data-mpi={i}>
                <div className="flex items-center justify-between gap-2" data-id="element-99" data-mp="snu7lcuaf6jn">
                  <Icon className="h-6 w-6 text-oro-dark" aria-hidden="true" data-id="element-100" data-mp="xnqd5gimv61b" />
                  <span className="font-mono text-[10px] font-bold uppercase tracking-widest text-oro-dark" data-id="element-101" data-mp="xptdatdi2fjr">
                    {bono.tag} · Gratis
                  </span>
                </div>
                <h3 className="mt-3 font-display text-[17px] font-bold leading-snug text-navy" data-id="element-102" data-mp="16maqe25fcni5">
                  {bono.title}
                </h3>
                <p className="mt-1.5 text-[14px] leading-relaxed text-navy-soft" data-id="element-103" data-mp="1gdy9nfrtuy8j">
                  {bono.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}